import { HttpClient } from '@euler/lib/request';
import { SystemStatus } from '@euler/model/SystemStatus';

export class SystemService {
  constructor(private readonly api: HttpClient) {}

  async getSystemStatus(): Promise<SystemStatus> {
    return await this.api.get().url('/system-status').future();
  }
}
